function getImageResolution(image){
  const resolution = {
    label: 'High',
    width: 0,
    height: 0,
    warn: false,
  }

  if (image && image.size){
    const lowResValue = 3600 // ~1200x900px
    const mediumResValue = 6400 // ~1600x1200px
    const imageRes = (image.size.original.width * image.size.original.height) / 300

    if (imageRes < mediumResValue){
      resolution.label = 'Medium'
      resolution.warn = true
    }

    if (imageRes < lowResValue){
      resolution.label = 'Low'
      resolution.warn = true
    }

    resolution.width = image.size.original.width
    resolution.height = image.size.original.height
  }

  return resolution
}

export default getImageResolution
